import { Stack } from "@mantine/core";

const PolicyCellStack = ({ children }) => (
  <Stack gap={4} py="sm" pr="xs">
    {children}
  </Stack>
);

export default PolicyCellStack;
